import React from 'react';

import Grid from '@material-ui/core/Grid';

import { AreaChart, Area, Tooltip, XAxis, YAxis, ReferenceLine } from 'recharts';

class AreaChartComponentAlternative extends React.Component {

    render() {
        let getValue = (x) => {
            if (x.length === 0) {
                return x.Value
            }
            else {
                return parseFloat(x.Value)
            }
        }

        return (
            <Grid container direction="row"
                justifyContent="center" alignItems="center">
                <AreaChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis dataKey={getValue} 
                        domain={['dataMin', 'dataMax']} />
                    <Tooltip />
                    <Area dataKey="Value" stroke="#8884d8"
                        fillOpacity={1} />

                    <ReferenceLine y={this.props.trigger_level[0]['value_1']}
                        label={this.props.trigger_level[0]['value_1_name']}
                        stroke="green" />
                    <ReferenceLine y={this.props.trigger_level[1]['value_2']}
                        label={this.props.trigger_level[1]['value_2_name']}
                        stroke="orange" />
                    <ReferenceLine y={this.props.trigger_level[2]['value_3']}
                        label={this.props.trigger_level[2]['value_3_name']}
                        stroke="red" />
                </AreaChart>
            </Grid>
        )
    }
}

export default AreaChartComponentAlternative;